import { Service } from '@/services/api';
import type { Opportunity } from '@/types/Opportunity';

class AccountService extends Service {
  async getCoverageTypes(id: number): Promise<string[]> {
    return this.get<string[]>(`/v2/account/${id}/coverage-types`).then(this.handleResponse);
  }

  async getOpportunitiesByAccount(id: number): Promise<Opportunity[]> {
    return this.get<Opportunity[]>(`/v2/account/${id}/opportunities`).then(this.handleResponse);
  }

  async getAccountsCountByEpicLookupCode(code: string): Promise<number> {
    return (await this.get(`/v2/accounts-count-by-epic-lookup-code/${code}`).then(this.handleResponse)) as number;
  }
}

export const accountService = new AccountService();
